import { Box, makeStyles } from '@material-ui/core';
import Text from '../../../../components/Text';
import admissionUtil from '../../../../utils/admissionUtil';
import { ReactComponent as RedFYA } from '../../../../static/images/RedFYA.svg';

const useStyles = makeStyles((theme) => ({
  showBusStop: {
    fontSize: '0.875rem',
    color: '#7D86A9',
    gap: '0.625rem',
    fontFamily: 'NotoSans-Medium',
  },
  decisionIcon: {
    width: '2rem',
    height: '2rem',
    borderRadius: '5px',
    color: '#FFFFFF',
  },
  sup: {
    fontWeight: '700',
    color: '#538FFF',
    fontSize: '0.75rem',
    fontFamily: 'NotoSans-Medium',
  },
  admissionTickIcon: {
    width: '1.875rem',
    height: '1.875rem',
    borderRadius: '5px',
    backgroundColor: '#997BFF',
    color: '#FFFFFF',
    padding: '0.25rem',
  },
}));

const WaitingTime = ({ data }) => {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center" gridGap="0.66rem" minWidth="9.5rem">
      <RedFYA className={classes.decisionIcon} />
      <Box display="flex" flexDirection="column" justifyContent="space-between">
        <Text fontSize="1rem" color="#2E4469">
          Max Waiting Time
        </Text>
        <Text>(HH:MM)</Text>
      </Box>
      <Text fontWeight="700" fontSize="1.875rem">
        {admissionUtil.secondsToHHMM(data?.admDecTime)}
      </Text>
    </Box>
  );
};

export default WaitingTime;
